export default __webpack_public_path__ + "static/media/CSS3.424c01c9.png";